import kinAgentMessageIcon from './agent-message-icon.svg';
import kinChatIcon from './chat-icon.svg';
import kinClose from './close.svg';
import kinNewChat from './frame.svg';
import kinSend from './frame-2.svg';
import kinHistory from './history.svg';
import kinSideTabButton from './side-tab-button.svg';
import kinUpload from './upload.svg';

export const KIN_AGENT_MESSAGE_ICON_URL = kinAgentMessageIcon;
export const KIN_CHAT_ICON_URL = kinChatIcon;
export const KIN_CLOSE_URL = kinClose;
export const KIN_HISTORY_URL = kinHistory;
export const KIN_NEW_CHAT_URL = kinNewChat;
export const KIN_SEND_URL = kinSend;
export const KIN_UPLOAD_URL = kinUpload;
export const KIN_SIDE_TAB_BUTTON_URL = kinSideTabButton;
